"use client";

import { useState } from "react";
import { installTabs } from "@/lib/content";
import { site } from "@/lib/site";
import { cn } from "@/lib/utils";
import { InstallCommand } from "./InstallCommand";

export function InstallTabs() {
  const [active, setActive] = useState(installTabs[0].id);
  const tab = installTabs.find((t) => t.id === active) ?? installTabs[0];

  return (
    <div>
      <div className="flex flex-wrap gap-2" role="tablist" aria-label="Installation instructions by platform">
        {installTabs.map((t) => (
          <button
            key={t.id}
            type="button"
            role="tab"
            aria-selected={t.id === active}
            onClick={() => setActive(t.id)}
            className={cn(
              "rounded-xl px-4 py-2 text-sm font-medium transition",
              t.id === active ? "bg-slate-900 text-white shadow-sm" : "border border-slate-200 bg-white text-slate-700 hover:bg-slate-50"
            )}
          >
            {t.label}
          </button>
        ))}
      </div>

      <div className="mt-6 rounded-2xl border border-slate-200 bg-white p-6 shadow-md sm:p-8">
        <p className="text-sm leading-relaxed text-slate-600">{tab.description}</p>
        <div className="mt-5 space-y-4">
          {tab.commands.map((c, i) => (
            <InstallCommand key={i} command={c.command} label={c.label} />
          ))}
        </div>
        {tab.downloads ? (
          <p className="mt-5 flex flex-wrap gap-2">
            {tab.downloads.map(([label, href]) => (
              <a key={href} href={href} className="inline-flex items-center rounded-xl bg-slate-900 px-4 py-2 text-sm font-semibold text-white transition hover:bg-slate-700">{label}</a>
            ))}
            <a href="/install-linux.sh" className="inline-flex items-center rounded-xl border border-slate-200 bg-white px-4 py-2 text-sm font-semibold text-slate-800 transition hover:bg-slate-50">Read the script</a>
            <span className="inline-flex items-center text-xs text-slate-600">v{site.debVersion} · <a className="ml-1 underline underline-offset-2" href={`https://github.com/Raktim94/Submify/releases/tag/v${site.debVersion}`}>release notes</a></span>
          </p>
        ) : null}
        <p className="mt-5 text-xs text-slate-500">
          Requires{" "}
          <a href="https://docs.docker.com/engine/install/" target="_blank" rel="noreferrer" className="font-medium text-brand-700 underline">
            Docker Engine and the Compose v2 plugin
          </a>
          . Once the containers are up, open <code className="rounded bg-slate-100 px-1 text-slate-800">http://localhost:2512</code> and create
          your first account at <code className="rounded bg-slate-100 px-1 text-slate-800">/register</code>.
        </p>
      </div>
    </div>
  );
}
